import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { StateType } from '../../../../../../../types';
import { selectUserType } from '../../../../../../../redux/selectors/auth';
import { changePartnerRequestStatus } from '../../../../../../../redux/actions/request';

const mapStateToProps = (state: StateType) => ({
  userType: selectUserType(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({ changePartnerRequestStatus }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
